
export const environment = {
  production: true,
  URL_WEB: 'https://testsitio.sorteoanahuac.mx/',
  URL_API_LEGALES: 'https://qaserviciossitioapp.sorteoanahuac.mx',
  URL_MICROSITIO: 'https://testpago.sorteoanahuac.mx/',
  URL_API_MAGNO: 'https://qaserviciosapp.sorteoanahuac.mx',
  URL_MICROSITIO_ANIV: '',
  URL_API_ANIV: '',
  ts: 'dDBrM25EM1MzZ1U3SWRARDlAclFTM3ZpQzAyJCUjQTlJcyRlIzNQNXIwZFU1NTFPbmMyMXNUM200YXM=',
};

